import { Link } from "react-router-dom";
import { ArrowUpRight, Navigation } from "lucide-react";
import { PageHeader } from "../components/site/PageHeader";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { HoursPanel } from "../components/site/HoursPanel";
import { ContactCard } from "../components/site/ContactActions";
import { PhotoPlaceholder } from "../components/site/PhotoPlaceholder";
import { OfferInline } from "../components/site/OfferBanner";
import { restaurant, fullAddress } from "../data/siteData";

export default function PracticalInfo() {
  return (
    <>
      <PageHeader testId="infos-header" eyebrow={`Depuis ${restaurant.since}`} lines={["Informations", <em key="i" className="text-[#E5B66C]">pratiques</em>]} intro={`Restaurant et pizzeria à Morangis, CAP SUD vous accueille depuis ${restaurant.since} au ${restaurant.street}.`} />
      <section className="pb-20">
        <div className="container-site grid gap-5 lg:grid-cols-2">
          <Reveal className="h-full"><ContactCard testId="infos-contact-card" /></Reveal>
          <Reveal className="h-full" delay={0.1}><HoursPanel testId="infos-hours-panel" /></Reveal>
        </div>
      </section>
      <section className="py-20 sm:py-28 bg-[#0E2A1B] border-t border-[#D4A359]/15">
        <div className="container-site grid gap-10 lg:grid-cols-12 lg:items-center">
          {restaurant.infoImage && (
          <Reveal className="lg:col-span-5">
            <PhotoPlaceholder src={restaurant.infoImage} alt="Façade de CAP SUD" label="Photo de la façade" sub="À ajouter par le restaurant" className="aspect-[4/3] rounded-[28px] border border-[#D4A359]/30" testId="infos-photo-slot" />
          </Reveal>
          )}
          <Reveal className={restaurant.infoImage ? "lg:col-span-7" : "lg:col-span-12"} delay={0.1}>
            <Eyebrow>Venir chez CAP SUD</Eyebrow>
            <p className="mt-5 font-display text-7xl sm:text-8xl text-[#D4A359]" data-testid="infos-since">{restaurant.since}</p>
            <p className="mt-3 text-lg text-[#F7F4EB]">L’année d’ouverture du restaurant, place Lucien Boilleau.</p>
            <p className="mt-6 text-[#D6CFC0]">{fullAddress}</p>
            <div className="mt-8 max-w-lg"><OfferInline testId="infos-offer" /></div>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={restaurant.directionsUrl} target="_blank" rel="noopener noreferrer" className="btn-gold" data-testid="infos-directions-button"><Navigation className="w-4 h-4" /> Itinéraire</a>
              <Link to="/commander-a-emporter" className="btn-ghost btn-terracotta" data-testid="infos-order-button">Commander à emporter <ArrowUpRight className="w-4 h-4" /></Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
